"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderDetailsComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const shared_1 = require("../../../../mma/shared");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
const constants = require("../../../util/constants");
const preorderlookup_component_1 = require("../../shared/preorder-lookup/preorderlookup.component");
class CSMMAPreOrderDetailsComponent extends preorderlookup_component_1.CSPreorderLookupOrderComponent {
    constructor(modalService, orderService, router, genericContentService, route) {
        super(orderService, genericContentService);
        this.modalService = modalService;
        this.orderService = orderService;
        this.router = router;
        this.genericContentService = genericContentService;
        this.route = route;
        this.isCancellingOrder = false;
        this.showPaymentMethods = false;
        this.isVerifiedUser = false;
    }
    ngOnDestroy() {
        this.modelRef = this.modalService.dismissAll();
    }
    ngOnInit() {
        this.getUrlParams();
    }
    /**
     * @returns login status of the user
     */
    getLoginStatus() {
        this.loader = true;
        this.orderService.getLoginStatus()
            .subscribe((loginStatus) => {
            this.isLoggedInUser = loginStatus.securityStatus === 4;
            if (this.isLoggedInUser) {
                this.getPreOrderDetails();
            }
            else {
                this.getVerificationStatus();
            }
        });
    }
    getVerificationStatus() {
        this.orderService.getVerificationStatus(this.preorderId).subscribe((status) => {
            if (status) {
                this.isVerifiedUser = true;
                this.getPreOrderDetails();
            }
            else {
                this.router.navigate(['/']);
            }
        });
    }
    getUrlParams() {
        this.preorderId = this.route.snapshot.paramMap.get(constants.preorderIdentifier);
        if (this.preorderId) {
            this.getLoginStatus();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    /**
     * @returns pre order details for MMA user
     */
    getPreOrderDetails() {
        this.loader = true;
        this.orderService.getPreOrderDetails(this.preorderId, null)
            .subscribe((preOrderDetails) => {
            if (preOrderDetails) {
                this.orderService.preOrderInfo = preOrderDetails;
                this.orderService.preOrderData = preOrderDetails[0];
                if (!this.orderService.preOrderData) {
                    this.error = this.setErrorMessage(constants.orderNotFound);
                }
                else {
                    this.setPreOrderPriceDetails();
                    this.setPreorderFlags(this.preorderId);
                }
            }
            else {
                this.error = this.setErrorMessage(constants.orderNotFound);
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    /**
     * @returns cached pre order details
     */
    setPreOrderPriceDetails() {
        var _a;
        if (this.orderService.preOrderData) {
            this.preOrderInfo = this.orderService.preOrderInfo;
            this.preOrderData = this.orderService.preOrderData;
            this.subcriptionDetails = (_a = this.orderService.preOrderData) === null || _a === void 0 ? void 0 : _a.preOrderSubscriptionDetails;
            this.getOrderSummary();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    setPreorderFlags(preOrderId) {
        if (preOrderId === this.preOrderData.preorderId) {
            if (this.preOrderData.status === constants.tenderFailed) {
                this.orderinProgress = true;
            }
            for (const lineItemCount of this.preOrderData.chargeableItems) {
                if (lineItemCount.status === constants.systemError) {
                    this.isSubStatusSystemError = true;
                }
            }
        }
        for (const sub of this.preOrderData.preOrderSubscriptionDetails) {
            if (sub.promoName) {
                let promo = sub.promoName;
                promo = promo.replace('$', '');
                const tempArr = promo.split(' ');
                if (tempArr.length > 0) {
                    sub.promoName = !isNaN(tempArr[0]) ? tempArr[0] : '';
                }
            }
            if (sub.status === constants.fulfilled) {
                this.orderinProgress = true;
            }
        }
    }
    openCancelPreorderModal(event) {
        this.modalError = null;
        if (event) {
            this.modelRef = this.modalService.open(this.modalCancelPreorder, { centered: true });
        }
    }
    cancelPreorder() {
        this.modalError = null;
        this.modalLoader = true;
        this.isCancellingOrder = true;
    }
    refreshPreorderDetails(event) {
        if (event) {
            this.getPreOrderDetails();
        }
        this.isCancellingOrder = false;
        this.modalLoader = false;
    }
    setModalError(event) {
        this.modalError = event;
        this.isCancellingOrder = false;
        this.modalLoader = false;
    }
    openEditPaymentModal(event) {
        if (event) {
            this.editPayment();
        }
    }
    editPayment() {
        this.showPaymentMethods = true;
    }
    updatePaymentMethodStatus(event) {
        this.showPaymentMethods = event;
    }
}
exports.CSMMAPreOrderDetailsComponent = CSMMAPreOrderDetailsComponent;
//# sourceMappingURL=preorder-details.component.js.map